export const mockData = [
  {
    roles: 1, paycheck: 1500,
    categories: ['br1', 'br2'],
    _id: "103893",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Stdout",
    lastName: "Margioglio",
    fisrtName: "Gino",
    cell: "392 98493438",
    slug: "We",
    id: "28dh9283h",
    description: "Ciao sono la descrizione",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    roles: 1, paycheck: 1500,
    categories: ['br1', 'br2'],
    _id: "103894",
    birthDate: "12/12/2001",
    time: "19:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Giallo",
    lastName: "Rossi",
    fisrtName: "Luca",
    cell: "345 6789012",
    slug: "Red",
    id: "39eh3983i",
    description: "Descrizione per Luca",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    roles: 1, paycheck: 1500,
    categories: ['br1', 'br2'],
    _id: "103895",
    birthDate: "12/12/2001",
    time: "22:12",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Verde",
    lastName: "Verdi",
    fisrtName: "Anna",
    cell: "333 1234567",
    slug: "Green",
    id: "19fj1030j",
    description: "Ciao da Mario",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    roles: 1, paycheck: 1500,
    categories: ['br1', 'br2'],
    _id: "103896",
    birthDate: "12/12/2001",
    time: "11:09",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Blu",
    lastName: "Bianchi",
    fisrtName: "Marco",
    cell: "389 4567890",
    slug: "Blue",
    id: "29dj2031k",
    description: "Descrizione di Marco",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    roles: 1, paycheck: 1500,
    categories: ['br1', 'br2'],
    _id: "103897",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Viola",
    lastName: "Neri",
    fisrtName: "Giulia",
    cell: "320 6547890",
    slug: "Purple",
    id: "38ej3941l",
    description: "Saluti da Giulia",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    roles: 1, paycheck: 1500,
    categories: ['br1', 'br2'],
    _id: "103898",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Arancio",
    lastName: "Moretti",
    fisrtName: "Paolo",
    cell: "391 2345678",
    slug: "Orange",
    id: "48fj4851m",
    description: "Messaggio da Paolo",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    roles: 1, paycheck: 1500,
    categories: ['br1', 'br2'],
    _id: "103899",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Rosa",
    lastName: "Ferrari",
    fisrtName: "Sara",
    cell: "347 9876543",
    slug: "Pink",
    id: "59gj5962n",
    description: "Ciao da Sara",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    roles: 1, paycheck: 1500,
    categories: ['br1', 'br2'],
    _id: "103900",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Indaco",
    lastName: "Pellegrini",
    fisrtName: "Davide",
    cell: "349 8765432",
    slug: "Indigo",
    id: "69hj6073o",
    description: "Descrizione di Davide",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    roles: 1, paycheck: 1500,
    categories: ['br1', 'br2'],
    _id: "103901",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Giorgio",
    lastName: "Leoni",
    fisrtName: "Claudio",
    cell: "360 7654321",
    slug: "Lion",
    id: "79ij7184p",
    description: "Claudio saluta tutti",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    roles: 1, paycheck: 1500,
    categories: ['br1', 'br2'],
    _id: "103902",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Francesco",
    lastName: "Esposito",
    fisrtName: "Mario",
    cell: "371 6543210",
    slug: "Frank",
    id: "89kj8295q",
    description: "Messaggio di Mario",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    roles: 1, paycheck: 1500,
    categories: ['br1', 'br2'],
    _id: "103903",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Lorenzo",
    lastName: "Ricci",
    fisrtName: "Giovanni",
    cell: "388 5432109",
    slug: "Larry",
    id: "99lj9306r",
    description: "Giovanni dice ciao",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    roles: 1, paycheck: 1500,
    categories: ['br1', 'br2'],
    _id: "103904",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Federico",
    lastName: "Romano",
    fisrtName: "Stefano",
    cell: "321 4321098",
    slug: "Fred",
    id: "10mj0417s",
    description: "Descrizione di Stefano",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    roles: 1, paycheck: 1500,
    categories: ['br1', 'br2'],
    _id: "103905",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Matteo",
    lastName: "Conti",
    fisrtName: "Alessandro",
    cell: "322 3210987",
    slug: "Matt",
    id: "11nj1528t",
    description: "Saluti da Alessandro",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    roles: 1, paycheck: 1500,
    categories: ['br1', 'br2'],
    _id: "103906",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Simone",
    lastName: "De Luca",
    fisrtName: "Francesca",
    cell: "324 2109876",
    slug: "Simon",
    id: "12oj2639u",
    description: "Descrizione per Francesca",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    roles: 1, paycheck: 1500,
    categories: ['br1', 'br2'],
    _id: "103907",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Andrea",
    lastName: "Mariani",
    fisrtName: "Elena",
    cell: "325 1098765",
    slug: "Andy",
    id: "13pj3740v",
    description: "Elena manda saluti",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    roles: 1, paycheck: 1500,
    categories: ['br1', 'br2'],
    _id: "103908",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Alessio",
    lastName: "Fontana",
    fisrtName: "Giorgia",
    cell: "326 9876543",
    slug: "Alex",
    id: "14qj4851w",
    description: "Messaggio da Giorgia",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    roles: 1, paycheck: 1500,
    categories: ['br1', 'br2'],
    _id: "103909",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Daniele",
    lastName: "Martini",
    fisrtName: "Chiara",
    cell: "327 8765432",
    slug: "Dan",
    id: "15rj5962x",
    description: "Descrizione di Chiara",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    roles: 1, paycheck: 1500,
    categories: ['br1', 'br2'],
    _id: "103910",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Filippo",
    lastName: "Fabbri",
    fisrtName: "Federica",
    cell: "328 7654321",
    slug: "Phil",
    id: "16sj6073y",
    description: "Federica dice ciao",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    roles: 1, paycheck: 1500,
    categories: ['br1', 'br2'],
    _id: "103911",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Tommaso",
    lastName: "Barbieri",
    fisrtName: "Valeria",
    cell: "329 6543210",
    slug: "Tom",
    id: "17tj7184z",
    description: "Messaggio da Valeria",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    roles: 1, paycheck: 1500,
    categories: ['br1', 'br2'],
    _id: "103912",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Leonardo",
    lastName: "Galli",
    fisrtName: "Giada",
    cell: "330 5432109",
    slug: "Leo",
    id: "18uj8295a",
    description: "Descrizione di Giada",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    roles: 1, paycheck: 1500,
    categories: ['br1', 'br2'],
    _id: "103913",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Emanuele",
    lastName: "Vitali",
    fisrtName: "Lorenza",
    cell: "331 4321098",
    slug: "Manu",
    id: "19vj9306b",
    description: "Saluti da Lorenza",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    roles: 1, paycheck: 1500,
    categories: ['br1', 'br2'],
    _id: "103914",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Gabriele",
    lastName: "Orlandi",
    fisrtName: "Barbara",
    cell: "332 3210987",
    slug: "Gab",
    id: "20wj0417c",
    description: "Messaggio di Barbara",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    roles: 1, paycheck: 1500,
    categories: ['br1', 'br2'],
    _id: "103915",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Pietro",
    lastName: "Ruggieri",
    fisrtName: "Alice",
    cell: "333 2109876",
    slug: "Pete",
    id: "21xj1528d",
    description: "Alice manda un saluto",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    roles: 1, paycheck: 1500,
    categories: ['br1', 'br2'],
    _id: "103916",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Nicolo",
    lastName: "Greco",
    fisrtName: "Bianca",
    cell: "334 1098765",
    slug: "Nick",
    id: "22yj2639e",
    description: "Descrizione per Bianca",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    roles: 1, paycheck: 1500,
    categories: ['br1', 'br2'],
    _id: "103917",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Samuele",
    lastName: "Sanna",
    fisrtName: "Laura",
    cell: "335 9876543",
    slug: "Sam",
    id: "23zj3740f",
    description: "Saluti da Laura",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    roles: 1, paycheck: 1500,
    categories: ['br1', 'br2'],
    _id: "103918",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Giuseppe",
    lastName: "Cattaneo",
    fisrtName: "Camilla",
    cell: "336 8765432",
    slug: "Joe",
    id: "24ak4851g",
    description: "Descrizione di Camilla",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    roles: 1, paycheck: 1500,
    categories: ['br1', 'br2'],
    _id: "103919",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Luca",
    lastName: "Bruno",
    fisrtName: "Carla",
    cell: "337 7654321",
    slug: "Luke",
    id: "25bk5962h",
    description: "Messaggio da Carla",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    roles: 1, paycheck: 1500,
    categories: ['br1', 'br2'],
    _id: "103920",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Vincenzo",
    lastName: "Parisi",
    fisrtName: "Martina",
    cell: "338 6543210",
    slug: "Vince",
    id: "26ck6073i",
    description: "Saluti da Martina",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    roles: 1, paycheck: 1500,
    categories: ['br1', 'br2'],
    _id: "103921",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Alberto",
    lastName: "Benedetti",
    fisrtName: "Elisa",
    cell: "339 5432109",
    slug: "Al",
    id: "27dk7184j",
    description: "Messaggio di Elisa",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    roles: 1, paycheck: 1500,
    categories: ['br1', 'br2'],
    _id: "103922",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Edoardo",
    lastName: "Ferri",
    fisrtName: "Cristina",
    cell: "340 4321098",
    slug: "Edo",
    id: "28ek8295k",
    description: "Saluti da Cristina",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    roles: 1, paycheck: 1500,
    categories: ['br1', 'br2'],
    _id: "103923",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Antonio",
    lastName: "Piras",
    fisrtName: "Teresa",
    cell: "341 3210987",
    slug: "Tony",
    id: "29fk9306l",
    description: "Messaggio di Teresa",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    roles: 1, paycheck: 1500,
    categories: ['br1', 'br2'],
    _id: "103924",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Carlo",
    lastName: "Valentini",
    fisrtName: "Anna",
    cell: "342 2109876",
    slug: "Carl",
    id: "30gk0417m",
    description: "Descrizione per Anna",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    roles: 1, paycheck: 1500,
    categories: ['br1', 'br2'],
    _id: "103925",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Franco",
    lastName: "Lombardi",
    fisrtName: "Clara",
    cell: "343 1098765",
    slug: "Frank",
    id: "31hk1528n",
    description: "Saluti da Clara",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    roles: 1, paycheck: 1500,
    categories: ['br1', 'br2'],
    _id: "103926",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Paolo",
    lastName: "Sartori",
    fisrtName: "Giulia",
    cell: "344 9876543",
    slug: "Paul",
    id: "32ik2639o",
    description: "Descrizione per Giulia",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    roles: 1, paycheck: 1500,
    categories: ['br1', 'br2'],
    _id: "103927",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Dario",
    lastName: "Colombo",
    fisrtName: "Margherita",
    cell: "345 8765432",
    slug: "Dar",
    id: "33jk3740p",
    description: "Saluti da Margherita",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    roles: 1, paycheck: 1500,
    categories: ['br1', 'br2'],
    _id: "103928",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Claudio",
    lastName: "Riva",
    fisrtName: "Alessia",
    cell: "346 7654321",
    slug: "Claud",
    id: "34kk4851q",
    description: "Messaggio di Alessia",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    roles: 1, paycheck: 1500,
    categories: ['br1', 'br2'],
    _id: "103929",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Luigi",
    lastName: "Grassi",
    fisrtName: "Beatrice",
    cell: "347 6543210",
    slug: "Gigi",
    id: "35lk5962r",
    description: "Descrizione per Beatrice",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    roles: 1, paycheck: 1500,
    categories: ['br1', 'br2'],
    _id: "103930",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Roberto",
    lastName: "Guerra",
    fisrtName: "Ludovica",
    cell: "348 5432109",
    slug: "Rob",
    id: "36mk6073s",
    description: "Messaggio da Ludovica",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    roles: 1, paycheck: 1500,
    categories: ['br1', 'br2'],
    _id: "103931",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Michele",
    lastName: "Riccardi",
    fisrtName: "Ginevra",
    cell: "349 4321098",
    slug: "Mike",
    id: "37nk7184t",
    description: "Descrizione per Ginevra",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    roles: 1, paycheck: 1500,
    categories: ['br1', 'br2'],
    _id: "103932",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Stefano",
    lastName: "Farina",
    fisrtName: "Nicole",
    cell: "350 3210987",
    slug: "Steve",
    id: "38ok8295u",
    description: "Saluti da Nicole",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    roles: 1, paycheck: 1500,
    categories: ['br1', 'br2'],
    _id: "103933",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Davide",
    lastName: "Serra",
    fisrtName: "Carlotta",
    cell: "351 2109876",
    slug: "Dave",
    id: "39pk9306v",
    description: "Messaggio di Carlotta",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    roles: 1, paycheck: 1500,
    categories: ['br1', 'br2'],
    _id: "103934",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Giacomo",
    lastName: "Bianco",
    fisrtName: "Flavia",
    cell: "352 1098765",
    slug: "Jack",
    id: "40qk0417w",
    description: "Descrizione per Flavia",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    roles: 1, paycheck: 1500,
    categories: ['br1', 'br2'],
    _id: "103935",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Giorgio",
    lastName: "Valli",
    fisrtName: "Luisa",
    cell: "353 9876543",
    slug: "George",
    id: "41rk1528x",
    description: "Saluti da Luisa",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
  {
    roles: 1, paycheck: 1500,
    categories: ['br1', 'br2'],
    _id: "103936",
    birthDate: "12/12/2001",
    time: "09:47",
    date: "12/12/2024",
    dateTime: 1747206690481,
    name: "Maurizio",
    lastName: "Donati",
    fisrtName: "Marta",
    cell: "354 8765432",
    slug: "Maury",
    id: "42sk2639y",
    description: "Messaggio da Marta",
    partecipants: 5,
    cap: "90044",
    state: "Italy",
    country: "Ecuador",
    note: "Ciao sono la nota",
  },
];
